import { useState } from "react";
import { toast } from "sonner";
import { Facebook, Linkedin, Mail, Link2, Share2 } from "lucide-react";

export default function ShareBar({ title, className = "" }) {
  const [url] = useState(() => (typeof window !== "undefined" ? window.location.href : ""));
  const enc = encodeURIComponent(url);
  const encT = encodeURIComponent(title || "");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link kopiert");
    } catch {
      toast.error("Kopieren nicht möglich");
    }
  };

  const links = [
    { icon: Facebook, label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc}` },
    { icon: Linkedin, label: "LinkedIn", href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}` },
    { icon: Share2, label: "WhatsApp", href: `https://wa.me/?text=${encT}%20${enc}` },
    { icon: Mail, label: "E-Mail", href: `mailto:?subject=${encT}&body=${enc}` },
  ];

  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid="share-bar">
      <span className="text-xs uppercase tracking-[0.2em] text-[#9A86B4]">Teilen</span>
      {links.map((l) => (
        <a key={l.label} href={l.href} target="_blank" rel="noreferrer" aria-label={l.label} className="text-[#6E5A82] hover:text-ink transition-colors">
          <l.icon className="w-[18px] h-[18px]" strokeWidth={1.5} />
        </a>
      ))}
      <button onClick={copy} aria-label="Link kopieren" data-testid="share-copy" className="text-[#6E5A82] hover:text-ink transition-colors">
        <Link2 className="w-[18px] h-[18px]" strokeWidth={1.5} />
      </button>
    </div>
  );
}
